import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_3 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-sm",
    title: _ctx.$t('humans.sendToHikvision')
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "form-label w-100" }, " Рисунок студента ", -1)),
          _createElementVNode("input", {
            class: "form-control",
            type: "file",
            accept: "image/*",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
          }, null, 32),
          (_ctx.state.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.state.error), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.state.preview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.state.preview,
                class: "w-100 border rounded",
                alt: "preview"
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_button_ui, {
            "button-class": "btn-primary",
            disabled: !_ctx.state.preview || _ctx.state.loader
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('humans.sendToHikvision')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}